import React from 'react'
import searchImg from '../../../favicon/search.png'


const SearchBar = ({ ...props }) => {
  const { title, searchOnChange, search, add2, create, setShowCreate } = props;

  const CloseIcon = () => {
    return (
      <>
        {search !== '' && (
          <div onClick={() => { searchOnChange('') }} className='absolute right-12 top-2 mr-1 cursor-pointer'>
            <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" class="rs-icon" aria-label="close" data-category="application"><path d="M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z"></path></svg>
          </div>

        )}
      </>
    )
  }



  return (
    <div className='ms:container ms:mx-auto px-4 ms:px-2 lg:mt-2 font-museo'>
      <div>
        <div className=' flex justify-between items-center py-2'>
          <h1 className='font-museobb sm:text-xl text-lg ' >{title}</h1>
          {add2 &&
            <div onClick={() => { setShowCreate(true) }} className='flex bg-[#0080C4] hover:no-underline sm:py-2 sm:px-3 px-2 py-1 rounded-r-full gap-x-3 rounded-l-full cursor-pointer '>
              <span className='bg-white rounded-full sm:w-5 sm:h-5 w-4 h-4 font-museob text-center sm:text-sm text-xs ' >+</span>
              <p className='hover:no-underline text-xs sm:text-sm text-white font-museob hover:text-white '>{create}</p>
            </div>}
        </div>
        <div className="flex flex-col  items-center justify-center w-full ">
          <div className="relative w-full  flex border-spacing-2 ">
            <input onChange={(e) => { searchOnChange(e?.target?.value) }} value={search} type="text" id="campaigns-search" name="campaigns-search" className=" block p-2.5 w-full h-full  text-sm text-gray-900  rounded-l-lg  border-2 border-[#404040] placeholder:font-museob placeholder:text-slate-400" placeholder={`Search for campaign`} required="" />
            <CloseIcon />
            <button type="submit" className=" px-2.5  text-sm   text-white bg-[#404040] rounded-r-lg border border-[#404040] hover:bg-[#404040]  focus:outline-none  ">
              <img src={searchImg} className="w-5 h-5" alt="search_icon"></img>
            </button>
          </div>
        </div>
      </div>
    </div >
  )
}

export default SearchBar
